import { render } from "./CRMDatatableTDTaskTitle.vue?vue&type=template&id=08a70006"
import script from "./CRMDatatableTDTaskTitle.vue?vue&type=script&lang=js"
export * from "./CRMDatatableTDTaskTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__